import ButtonGroupContainer  from "../../../Components/Button/ButtonGroup/ButtonGroupContainer";

const ButtonGroup = () => {
  return <ButtonGroupContainer />;
};

export default ButtonGroup;
